import { __decorate } from "tslib";
import { Router } from '@angular/router';
import { CRUD_ROUTE_STATE_ITEM_DEFAULTS, CRUD_ROUTE_STATE_LIST } from '@common/crud/frontend-shared';
import { PaymentReminderTarget } from '@common/payment-reminder/shared';
import { provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import { RouterLinkResolverService } from '@core/shared/feature';
import { CompanyPaymentReminderInstruction } from './company-reminder-widget';
import * as i0 from "@angular/core";
let PaymentReminderFrontendAdminFeature = /*#__PURE__*/(() => {
  let PaymentReminderFrontendAdminFeature = class PaymentReminderFrontendAdminFeature extends FrontendFeaturePlugin {
    displayRemindersForTarget(target, targetId) {
      const routerLinkResolver = this.injector.get(RouterLinkResolverService);
      const routerLink = routerLinkResolver.resolveRouterLink('admin', 'payment-reminder-manager');
      const state = {
        [CRUD_ROUTE_STATE_LIST]: {
          filters: {
            target,
            targetId
          }
        }
      };
      this.injector.get(Router).navigate([routerLink], {
        state
      });
    }
    createReminderForTarget(target, targetId) {
      const routerLinkResolver = this.injector.get(RouterLinkResolverService);
      const routerLink = routerLinkResolver.resolveRouterLink('admin', 'payment-reminder-manager', 'new');
      const state = {
        [CRUD_ROUTE_STATE_ITEM_DEFAULTS]: {
          target,
          targetId
        }
      };
      this.injector.get(Router).navigate(routerLink, {
        state
      });
    }
    getFeatureContext() {
      return {"package":"@common/payment-reminder/frontend-admin","featureId":"common-payment-reminder"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Zahlungserinnerungen',
          routerLink: 'payment-reminder',
          icon: 'exclamation-triangle',
          priority: 7
        }]
      });
      functionality.defineItemActions([{
        modelId: 'UserItem',
        displayContext: ['admin', 'crud'],
        label: 'Zahlungserinnerung erstellen',
        icon: 'exclamation-triangle',
        action: item => this.createReminderForTarget(PaymentReminderTarget.user, item.id)
      }, {
        modelId: 'CompanyItem',
        displayContext: ['admin', 'crud'],
        label: 'Zahlungserinnerung erstellen',
        icon: 'exclamation-triangle',
        action: item => this.createReminderForTarget(PaymentReminderTarget.company, item.id)
      }
      // TODO: currently impossible because PaymentReminder Dashboard does not support filtering by a target
      // {
      // 	modelId:'UserItem',
      // 	displayContext:['admin','crud'],
      // 	label:'Zahlungserinnerungen anzeigen',
      // 	icon:'exclamation-triangle',
      // 	action:(item) => {}
      // },
      // {
      // 	modelId:'CompanyItem',
      // 	displayContext:['admin','crud'],
      // 	label:'Zahlungserinnerungen anzeigen',
      // 	icon:'exclamation-triangle',
      // 	action:(item) => {}
      // },
      ]);
      functionality.defineModelInstructions([{
        modelId: 'CompanyItem',
        targetSlotId: 'sidebar',
        displayContext: ['admin', 'crud'],
        displayInEditModes: ['edit'],
        instructions: [new CompanyPaymentReminderInstruction({})]
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPaymentReminderFrontendAdminFeature_BaseFactory;
        return function PaymentReminderFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵPaymentReminderFrontendAdminFeature_BaseFactory || (ɵPaymentReminderFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PaymentReminderFrontendAdminFeature)))(__ngFactoryType__ || PaymentReminderFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PaymentReminderFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'payment-reminder',
          loadChildren: () => import('./payment-reminder-admin.module').then(m => m.PaymentReminderFrontendAdminModule)
        }])
        // provideFeatureAddonRoutes([])
        ]
      });
    }
  };
  PaymentReminderFrontendAdminFeature = __decorate([ClassName("PaymentReminderFrontendAdminFeature")], PaymentReminderFrontendAdminFeature);
  return PaymentReminderFrontendAdminFeature;
})();
export { PaymentReminderFrontendAdminFeature };